import type { RouteRecordRaw } from 'vue-router'

const qualityRoutes: RouteRecordRaw = {
  path: '/quality',
  name: 'Quality',
  redirect: '/quality/inspection',
  meta: { title: '质检管理', icon: 'icon-check-circle' },
  children: [
    { path: 'inspection', name: 'QualityInspection', component: () => import('@/views/quality/InspectionList.vue'), meta: { title: '质检单', permissions: ['quality:inspection:view'] } },
    { path: 'goal', name: 'QualityGoal', component: () => import('@/views/quality/GoalList.vue'), meta: { title: '质量目标', permissions: ['quality:goal:view'] } },
    { path: 'procedure', name: 'QualityProcedure', component: () => import('@/views/quality/ProcedureList.vue'), meta: { title: '质量程序', permissions: ['quality:procedure:view'] } },
    { path: 'feedback', name: 'QualityFeedback', component: () => import('@/views/quality/FeedbackList.vue'), meta: { title: '质量反馈', permissions: ['quality:feedback:view'] } },
  ],
}
export default qualityRoutes
